<template>
  <div class="esg-strategy skinc-container">
    <TogetherText />
  </div>
</template>

<script>
import TogetherText from './TogetherText.vue';
export default {
  name: 'ESGStrategy',
  components: {
    TogetherText
  }
};
</script>

<style scoped>
.esg-strategy {
  width: 100%;
  min-height: 60vh;
  position: relative;
  padding-top: 100px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
